import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { PropTableValues } from '../../src/components';
import { Label } from '@primer/react';
import { Link } from 'gatsby';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {AnchorNav} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <Note mdxType="Note">
      <p><inlineCode parentName="p">{`AnchorNav`}</inlineCode>{` is designed to fix to the top of the viewport, and requires markup outside of the scope of the component to behave correctly.`}</p>
      <p>{`Please refer to our `}<a parentName="p" {...{
          "href": "https://primer.style/brand/storybook/?path=/story/components-anchornav--playground"
        }}>{`Storybook examples`}</a>{` to see the component in a full-screen context as originally intended.`}</p>
    </Note>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Container sx={{position: 'relative', overflowX: 'scroll'}}>
  <AnchorNav>
    <AnchorNav.Link href="#basic-section1">Section one</AnchorNav.Link>
    <AnchorNav.Link href="#basic-section2">Section two</AnchorNav.Link>
    <AnchorNav.Link href="#basic-section3">Section three</AnchorNav.Link>
    <AnchorNav.Link href="#basic-section4">Section four</AnchorNav.Link>
    <AnchorNav.Link href="#basic-section5">Section five</AnchorNav.Link>
    <AnchorNav.Action href="#">Sign up</AnchorNav.Action>
  </AnchorNav>

  <section
    id="basic-section1"
    style={{
      padding: '100px 2rem',
      backgroundColor: 'var(--base-color-scale-lemon-0)',
    }}
  >
    Section 1
  </section>
  <section
    id="basic-section2"
    style={{
      padding: '100px 2rem',
      backgroundColor: 'var(--base-color-scale-yellow-0)',
    }}
  >
    Section 2
  </section>
  <section
    id="basic-section3"
    style={{
      padding: '100px 2rem',
      backgroundColor: 'var(--base-color-scale-lime-0)',
    }}
  >
    Section 3
  </section>
  <section
    id="basic-section4"
    style={{
      padding: '100px 2rem',
      backgroundColor: 'var(--base-color-scale-green-0)',
    }}
  >
    Section 4
  </section>
  <section
    id="basic-section5"
    style={{
      padding: '100px 2rem',
      backgroundColor: 'var(--base-color-scale-teal-0)',
    }}
  >
    Section 5
  </section>
</Container>
`}</code></pre>
    <h3>{`Fewer links`}</h3>
    <p><inlineCode parentName="p">{`AnchorNav`}</inlineCode>{` implementations with fewer than `}<inlineCode parentName="p">{`5`}</inlineCode>{` links, will automatically align links to the `}<inlineCode parentName="p">{`start`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Container sx={{position: 'relative', overflowX: 'scroll'}}>
  <AnchorNav>
    <AnchorNav.Link href="#fewer-links-section1">Section one</AnchorNav.Link>
    <AnchorNav.Link href="#fewer-links-section2">Section two</AnchorNav.Link>
    <AnchorNav.Link href="#fewer-links-section3">Section three</AnchorNav.Link>
    <AnchorNav.Action href="#">Sign up</AnchorNav.Action>
  </AnchorNav>

  <section
    id="fewer-links-section1"
    style={{
      padding: '100px 2rem',
      backgroundColor: 'var(--base-color-scale-lemon-0)',
    }}
  >
    Section 1
  </section>
  <section
    id="fewer-links-section2"
    style={{
      padding: '100px 2rem',
      backgroundColor: 'var(--base-color-scale-yellow-0)',
    }}
  >
    Section 2
  </section>
  <section
    id="fewer-links-section3"
    style={{
      padding: '100px 2rem',
      backgroundColor: 'var(--base-color-scale-lime-0)',
    }}
  >
    Section 3
  </section>
</Container>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`AnchorNav `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['AnchorNav.Link', 'AnchorNav.Action', 'ReactNode']} addLineBreaks mdxType="PropTableValues" />{`,`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Valid child nodes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`enableDefaultBgColor`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Enable the idle state background color, which is transparent by default`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`hideUntilSticky`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`When true, the anchor nav will hide until it is sticky.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
      </tbody>
    </table>
    <h3 id="AnchorNav-link">
  AnchorNav.Link <Label mdxType="Label">Required</Label>
    </h3>
    <p><inlineCode parentName="p">{`AnchorNav.Link`}</inlineCode>{` are anchor links that feature in the menubar`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Required. Label text`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies a custom class`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`href`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Required. Local identifier for the anchored element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`isActive`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Manually indicate that the link is active`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Additional props can be passed to the `}<inlineCode parentName="p">{`<a>`}</inlineCode>{` element. `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attributes"
      }}>{`See MDN for a list of props`}</a>{` accepted by the `}<inlineCode parentName="p">{`<anchor>`}</inlineCode>{` element.`}</p>
    <h3 id="AnchorNav-action">
  AnchorNav.Action <Label mdxType="Label">Required</Label>
    </h3>
    <p><inlineCode parentName="p">{`AnchorNav.Action`}</inlineCode>{` is the primary call to action for the AnchorNav`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Required. Label text`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies a custom class`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`href`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Required. Local identifier for the anchored element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Additional props can be passed to the `}<inlineCode parentName="p">{`<a>`}</inlineCode>{` element. `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attributes"
      }}>{`See MDN for a list of props`}</a>{` accepted by the `}<inlineCode parentName="p">{`<anchor>`}</inlineCode>{` element.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      